import './App.css';
import { useEffect, useMemo, useState } from 'react';
import ReactGA from 'react-ga4';
import ModalWorkingHours from './modalWorkHours/modalWorkHours';
ReactGA.initialize('G-TCZDJE82ES');

const goToWhatsapp = () => {
  ReactGA.event("whatsapp-clicked")
  window.open('https://api.whatsapp.com/send/?phone=5511970196824&text&type=phone_number&app_absent=0', '_blank');
}
const goToOwnMenu = () => {
  ReactGA.event("own-menu-clicked")
  const search = window.location.search;
  window.open('https://delivery.roleplayburger.com.br' + search, '_blank');
}
const goToIfood = () => {
  ReactGA.event("ifood-clicked")
  window.open('https://www.ifood.com.br/delivery/sao-paulo-sp/roleplay-----hamburguer-artesanal-conjunto-residencial-butanta/00d5f1f5-9c39-4be4-a31f-e65502c1b275', '_blank');
}

const API_BASE = 'https://api.roleplayburger.com.br';
const TZ = 'America/Sao_Paulo';
const DAY_KEYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

// usado só como fallback se a API não responder
const workingHours = {
  0: [['18:00', '23:30']],
  1: [],
  2: [],
  3: [['18:00', '23:30']],
  4: [['18:00', '23:30']],
  5: [['18:00', '23:30']],
  6: [['18:00', '23:30']],

}

const pad = (n) => String(n).padStart(2, '0');

// "18:00" + 330min -> "23:30"
const addMinutesToClock = (start, minutes) => {
  const [h, m] = String(start).split(':').map(Number);
  const total = (((h * 60 + m + Number(minutes)) % 1440) + 1440) % 1440;
  return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
}

// openingHours da API -> { 0: [['18:00','23:30']], 1: [], ... }
const hoursFromApi = (openingHours) => {
  const apiDays = (openingHours && openingHours.days) || {};
  return DAY_KEYS.reduce((acc, key, index) => {
    acc[index] = (apiDays[key] || []).map((shift) => [
      shift.start,
      shift.end || addMinutesToClock(shift.start, shift.duration),
    ]);
    return acc;
  }, {});
}

// tudo abaixo lê o relógio no fuso da loja, não no do aparelho do cliente
const tzDateKey = (date) => new Intl.DateTimeFormat('en-CA', {
  timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
}).format(date);

const tzClock = (date) => new Intl.DateTimeFormat('pt-BR', {
  timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false,
}).format(date);

const tzWeekday = (date) => {
  const short = new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'short' }).format(date);
  return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(short);
}
const days = {
  0: "Domingo",
  1: "Segunda",
  2: "Terça",
  3: "Quarta",
  4: "Quinta",
  5: "Sexta",
  6: "Sábado",

}
const isOpened = (table = workingHours) => {
  const date = new Date();
  const day = tzWeekday(date);
  const now = tzClock(date); // sempre "HH:MM" zero-padded, no fuso da loja
  const open = (table[day] || []).some(([start, end]) => {
    return start <= now && now < end;
  });

  return open;
}

// "Hoje as 18:00" / "Amanhã as 18:00" / " em 20 minutos", a partir do nextOpening da API
const nextOpenFromIso = (iso) => {
  if (!iso) {
    return "";
  }
  const target = new Date(iso);
  if (isNaN(target.getTime())) {
    return "";
  }
  const now = new Date();
  const leftMinutes = Math.round((target.getTime() - now.getTime()) / 60000);
  if (leftMinutes <= 0) {
    return "";
  }
  if (leftMinutes < 60) {
    return ` em ${leftMinutes} ${leftMinutes === 1 ? 'minuto' : 'minutos'}`;
  }
  const targetKey = tzDateKey(target);
  let week = days[tzWeekday(target)];
  if (targetKey === tzDateKey(now)) {
    week = "Hoje";
  } else if (targetKey === tzDateKey(new Date(now.getTime() + 86400000))) {
    week = "Amanhã";
  }
  return `${week} as ${tzClock(target)}`;
}
function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
const deg2rad = (deg) => {
  return deg * (Math.PI / 180)
}

// fallback offline: varre a tabela local procurando a próxima abertura
const nextOpen = (mockData) => {
  let date = new Date();
  if (mockData) {
    date = new Date(mockData);
  }
  const day = date.getDay();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const now = `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;

  for (let i = 0; i <= 6; i++) {

    let checkDay = day
    if (checkDay + i > 6) {
      checkDay = 0;
    } else {
      checkDay = checkDay + i;
    }
    for (const [start,] of workingHours[checkDay]) {
      if (i === 0 && start < now) {
        continue; // Se for hoje mas antes do horário de abertura, continue procurando
      }
      // Encontrou o próximo horário de abertura
      const nextDate = addDays(date, i);
      const [nextHours, nextMinutes] = start.split(":");
      nextDate.setHours(nextHours, nextMinutes, 0, 0); // Configura para o próximo horário de abertura
      let week = days[checkDay];
      if (day === checkDay) {
        week = "Hoje";


        let leftMinutes = Number(nextMinutes - minutes) + (Number(nextHours - hours) * 60);

        if (leftMinutes < 60) {

          return ` em ${leftMinutes} minutos`;
        }


      } else if (day + i === checkDay) {
        week = "Amanhã";

      }


      return `${week} as ${nextHours}:${nextMinutes}`;

    }

  }
};
function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [nextOpenText, setNextOpenText] = useState("");
  const [location, setLocation] = useState(null);
  const [distance, setDistance] = useState(0);
  const [status, setStatus] = useState(null); // /menu/status; null = ainda não respondeu
  const [tick, setTick] = useState(0);

  // horários da API quando disponíveis, tabela local como fallback
  const hoursTable = useMemo(() => {
    if (status && status.openingHours) {
      return hoursFromApi(status.openingHours);
    }
    return workingHours;
  }, [status]);

  const opened = useMemo(() => {
    if (status && typeof status.open === 'boolean') {
      return status.open;
    }
    return isOpened(hoursTable);
    // tick força o recálculo do fallback ao longo do tempo
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, hoursTable, tick]);

  const statusText = useMemo(() => {
    if (opened) {
      return "Estamos Abertos";
    }
    const prefix = status && status.status === 'PAUSED' ? "Pausado, voltamos" : "Fechado, abrimos";
    return nextOpenText ? `${prefix}${nextOpenText.startsWith(' ') ? '' : ' '}${nextOpenText}` : "Fechado no momento";
  }, [opened, status, nextOpenText]);


  const inDeliveryArea = useMemo(() => {
    if (distance === null) {
      return null;
    }
    if (distance <= 5) {
      return true;
    } else if (distance <= 7) {
      return true;
    } else {
      return false;
    }
  }, [distance])
  const locationText = useMemo(() => {
    if (distance === null || distance === 0) {
      return null;
    }
    if (distance <= 5) {
      ReactGA.event("user-in-delivery-area", { distance: distance })
      return "Atendemos sua região";
    } else if (distance <= 7) {
      ReactGA.event("user-in-ifood-delivery-area", { distance: distance })
      return "Atendemos sua região, somente pelo Ifood";
    } else {
      ReactGA.event("user-not-in-area", { distance: distance })
      return "Infelizmente não atendemos sua região";
    }

  }, [distance])

  const getLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      ReactGA.event("location-clicked")
      ReactGA.set({ location: `${position.coords.latitude},${position.coords.longitude}` });
      setLocation(position);
    }
    )
  }
  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }
  useEffect(() => {
    const cords = { lat: -23.576, lon: -46.726 };
    if (location) {
      const distance = getDistanceFromLatLonInKm(location.coords.latitude, location.coords.longitude, cords.lat, cords.lon);
      setDistance(distance)
      ReactGA.event("latlon", { "latlon": `${location.coords.latitude},${location.coords.longitude}`, distance: distance })
    } else {

      setDistance(null)
    }
  }, [location])
  useEffect(() => {
    //check if location permission is granted without show the popup
    try {
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state === 'granted') {
          getLocation();
        }
      });
    } catch {

    }
    const i = setInterval(() => {
      setTick((t) => t + 1);
    }, 15000);
    return () => clearInterval(i);
  }, []);

  // busca o estado real da loja; erro mantém o último valor bom (ou o fallback local)
  useEffect(() => {
    let alive = true;
    const load = () => {
      fetch(`${API_BASE}/menu/status`, { cache: 'no-store' })
        .then((r) => {
          if (!r.ok) {
            throw new Error(`HTTP ${r.status}`);
          }
          return r.json();
        })
        .then((data) => {
          if (alive) {
            setStatus(data);
          }
        })
        .catch(() => { /* mantém o que já estava */ });
    };
    load();
    const i = setInterval(load, 60000);
    const onFocus = () => {
      if (document.visibilityState === 'visible') {
        load();
      }
    };
    document.addEventListener('visibilitychange', onFocus);
    window.addEventListener('focus', onFocus);
    return () => {
      alive = false;
      clearInterval(i);
      document.removeEventListener('visibilitychange', onFocus);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  // texto de "abrimos ..." — usa o nextOpening da API, cai pra varredura local se não houver
  useEffect(() => {
    if (status && status.nextOpening) {
      setNextOpenText(nextOpenFromIso(status.nextOpening));
    } else if (!status) {
      setNextOpenText(nextOpen());
    } else {
      setNextOpenText("");
    }
  }, [status, tick]);
  return (
    <div className="App">
      <ModalWorkingHours workingHours={hoursTable} days={days} isOpen={isOpen} onClose={() => { setIsOpen(false) }} />
      <img src={"/back.png"} className="background-image" alt="logo" />
      <img src={"/logo.png"} className="App-logo" alt="logo" />
      <p className='motd'>Peça já por um dos nossos canais</p>
      <div onClick={() => { setIsOpen(true); ReactGA.event("look-working-hours") }} className='hour-container'>
        <div className={'hour-status ' + (opened ? "open" : "close")}>
          {statusText}

        </div>
        <p className='hour-text'>Ver Horários</p>
      </div>
      {
        locationText !== null ? <p className={'location-final ' + (inDeliveryArea ? 'true' : 'false')}>{locationText}</p> : <p onClick={getLocation} className='location-text'>Clique aqui para saber se atendemos sua região</p>

      }

      <div onClick={goToOwnMenu} className='own-menu featured'>
        <img src={"/logoYellow.png"} className="logo" alt="menu" />
        <div className="own-menu-text">
          <div className='internal'>
            <h3 className='menu-text'>Cardápio Próprio</h3>
            <p className='menu-text'>Opções até 30% mais baratas do que pelo IFood</p>
          </div>
        </div>
      </div>


      <div onClick={goToIfood} className='own-menu'>
        <img src={"/icone-ifood.png"} className="logo" alt="menu" />
        <div className="own-menu-text">
          <div className='internal'>
            <h3 className='menu-text'>IFood - Cardápio</h3>
          </div>

        </div>
      </div>
      <p className='other-apps'>
        Ou procure a gente no <span>Keeta</span> e no <span>99</span>
      </p>

      <p className='contact-text'>
        Ou entre em contato conosco<br /> pelo WhatsApp
      </p>

      <img onClick={goToWhatsapp} src={"/whatsapp.png"} className="whatsapp" alt="whatsapp" />
    </div>
  );
}

export default App;
